/** @format */

const template = `
<div class="row">
  <div class="col-6">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.DECISION</h4>
      <text-with-default-missing-value
        value-key="$ctrl.hasFinalDecision() ? $ctrl.valueKey($ctrl.applicationValue('state'), 'STUDENT_APPLICATIONS.STATE.') : null"
        is-option="true">
      </text-with-default-missing-value>
    </div>
  </div>
  <div class="col-6" ng-if="$ctrl.applicationValue('decision.resolutionRationale')">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.RESOLUTION_RATIONALE</h4>
      <span class="text-area-static">{{$ctrl.applicationValue('decision.resolutionRationale')}}</span>
    </div>
    <div class="form-group-mimic">
      <h4
        translate="{{'SHOW_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.application.type + '.CONDITIONS'}}"
        ng-if="$ctrl.application.state === 'CONDITIONAL'"></h4>
      <span ng-if="$ctrl.application.state === 'CONDITIONAL'" class="text-area-static"
        >{{$ctrl.applicationValue('decision.conditionalApprovalTerms')}}</span
      >
    </div>
  </div>
</div>
<recommendation
  formal-recommendation="$ctrl.decision.formalRecommendation"
  content-recommendation="$ctrl.decision.contentRecommendation"
  approval-request-type="$ctrl.application.type"></recommendation>
<div class="row">
  <div class="col-6">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.APPROVAL_DATE</h4>
      <span>{{$ctrl.applicationValue('decision.approvalDate') | localDateFormat}}</span>
    </div>
  </div>
  <div class="col-6" ng-if="$ctrl.applicationValue('handler.fullName')">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.HANDLED_BY</h4>
      <span>{{$ctrl.applicationValue('handler.fullName')}}</span>
    </div>
  </div>
</div>
`;
export default template;
